export default function addObjectParamsToPath(path, obj = {}) {
  return `${path}${Object.keys(obj).length > 0 ? `?${new URLSearchParams(obj).toString()}` : ''}`;
}
